var map = {
	"./Columns.svg": "./js/components/svg/Columns.svg?vue-template",
	"./Export.svg": "./js/components/svg/Export.svg?vue-template",
	"./Full.svg": "./js/components/svg/Full.svg?vue-template",
	"./Mosaic.svg": "./js/components/svg/Mosaic.svg?vue-template"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js/components/svg sync \\.svg$";